import {FormControlLabel, Radio, RadioGroup} from "@mui/material";
import DayTimeIntakes from "./DayTimeIntakes";
import TimeIntakes from "./TimeIntakes";
import {Consts} from "../../pages/consts";
import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";

const TimingTypeRadioGroup = ({selectedDrug, setSelectedDrug, setIntakesCompleted}) => {
  const { t } = useTranslation();
  const [timingType, setTimingType] = useState(selectedDrug?.timingType || Consts.DAY_TIMES);

  useEffect(() => {
    if (selectedDrug?.intakes?.length > 0 && selectedDrug?.intakeType === Consts.REGULARLY && selectedDrug?.timingType === Consts.TIMES) {
      setSelectedDrug({...selectedDrug, intakes: buildTimesContent()});
    }
  }, []);

  const buildTimesContent = () => {
    return selectedDrug?.intakes?.map((intake) => {
      return {
        intakeTime: intake?.intakeTime,
        dosage: intake?.dosage,
        dosageUnit: selectedDrug?.dosageUnit,
      };
    });
  };

  const handleSelectingTimingType = (value) => {
    setTimingType(value);

    const arr = value === Consts.TIMES
      ? Array.from({ length: 5 },
        () => ({ intakeTime: "", dosage: 0, dosageUnit: selectedDrug?.dosageUnit }))
      : Consts.DEFAULT_DAY_TIME_INTAKES;

    setIntakesCompleted(false);
    setSelectedDrug({...selectedDrug, timingType: value, intakes: arr});
  };

  const handleSetIntake = (intake, index) => {
    let newArr= selectedDrug.intakes?.map((intk, i) => i === index ? intake : intk);

    setSelectedDrug({...selectedDrug, intakes: newArr});
    const filledOut = newArr?.filter(intake => !isNaN(intake?.dosage) && intake?.dosage > 0);

    if(timingType === Consts.DAY_TIMES) {
      setIntakesCompleted(filledOut?.length > 0);
    } else if(timingType === Consts.TIMES) {
      setIntakesCompleted(filledOut?.length >= 5);
    }
  }

  // Only for timingType === Consts.TIMES
  const addNewIntakeRow = (intake) => {
    setSelectedDrug({...selectedDrug, intakes: [...selectedDrug?.intakes, intake]});
  }

  return (
    <RadioGroup
      aria-labelledby="time-day-time-group"
      name="time-day-time-group"
      value={ timingType }
      defaultValue={ timingType }
      onChange={ (e) => handleSelectingTimingType(e.target.value) }
      className="timing-type-radio-group"
    >
      <div className="timing-type-radio-group__options">
        <FormControlLabel
          value={Consts.DAY_TIMES}
          control={<Radio />}
          label={<span className="timing-type-radio-group__label">{t("select_day_times")}</span>}
          className="timing-type-radio-group__option"
        />
        <FormControlLabel
          value={Consts.TIMES}
          control={<Radio />}
          label={<span className="timing-type-radio-group__label">{t("or_specify_more_than_4_times_daily")}</span>}
          className="timing-type-radio-group__option"
        />
      </div>
      <DayTimeIntakes
        timingType={ timingType }
        intakes={ selectedDrug?.intakes }
        onSetIntake={ handleSetIntake }
      />
      <TimeIntakes
        timingType={ timingType }
        intakes={ selectedDrug?.intakes }
        onSetIntake={ handleSetIntake }
        onAddNewRow={addNewIntakeRow}
      />
    </RadioGroup>
  );
};

export default TimingTypeRadioGroup;
